import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-botswana-home-loan-repayment.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorBotswanaHomeLoanRepayment = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorBotswanaHomeLoanRepayment, _super);
    function CalculatorBotswanaHomeLoanRepayment(element) {
        return _super.call(this, element) || this;
    }
    CalculatorBotswanaHomeLoanRepayment.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputPurchasePrice = this.element.querySelector('input[name=purchase_price]');
        this.inputDeposit = this.element.querySelector('input[name=deposit_amount]');
        this.inputInterest = this.element.querySelector('.js-interest_rate');
        this.inputTerm = this.element.querySelector('input[name=term_months]');
        this.totalMonthlyRepayment = this.element.querySelector('.js-monthly-repayment');
        this.totalInterest = this.element.querySelector('.js-total-interest');
        this.termMonthsDisplay = this.element.querySelector('.js-term-months');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-botswana-home-loan-repayment__result--terms');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        this.calculate();
        TooltipsService.initTooltips();
    };
    CalculatorBotswanaHomeLoanRepayment.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            _this.totalMonthlyRepayment.innerHTML = "-";
            _this.totalInterest.innerHTML = "-";
            _this.termMonthsDisplay.innerHTML = "-";
        });
    };
    CalculatorBotswanaHomeLoanRepayment.prototype.calculate = function () {
        var purchasePrice = parseFloat(this.inputPurchasePrice ? this.inputPurchasePrice.value : 0);
        var terms = parseFloat(this.inputTerm.value);
        var deposit = parseFloat(this.inputDeposit.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var monthlyRate = interestRate / 12 / 100;
        // Validation (optional)
        // if (!purchasePrice || !term || !interestRate) {
        //     console.error("Missing required input values");
        //     return;
        // }
        // Loan amount = purchase price - deposit
        var loanAmount = purchasePrice - deposit;
        // Monthly installment using PMT function
        var monthlyInstallment = this.PMT(monthlyRate, terms, -loanAmount);
        // Total amount paid over the loan term
        var totalPaid = monthlyInstallment * terms;
        // Display values (use roundFormatter with 2 decimal places and formatting)
        var formattedInstallment = this.roundFormatter(monthlyInstallment, 2, true);
        // Update UI
        this.totalMonthlyRepayment.innerHTML = formattedInstallment;
        this.totalInterest.innerHTML = interestRate.toFixed(2) + "%";
        this.termMonthsDisplay.innerHTML = terms + " months";
    };
    CalculatorBotswanaHomeLoanRepayment.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorBotswanaHomeLoanRepayment.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorBotswanaHomeLoanRepayment.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorBotswanaHomeLoanRepayment.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorBotswanaHomeLoanRepayment;
}(Base));
export { CalculatorBotswanaHomeLoanRepayment };



//////////////////
// WEBPACK FOOTER
// ./components-botswana/calculator-botswana-home-loan-repayment/calculator-botswana-home-loan-repayment.component.ts
// module id = 783
// module chunks = 0